import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import useDialog from 'components/Dialog/useDialog';
import { STARTUP_RELATION_STATUS } from 'constants/startup';
import { ROUTE_STARTUP_PATH } from 'routes';
import { changeInviteStatus } from '../../modules/actions';
import StartupRowHeader from './StartupRowHeader';
// import StartupRowSocial from './StartupRowSocial';
import StartupRowButtons from './StartupRowButtons';
import StartupRowLoading from './StartupRowLoading';
import StartupRowCountry from './StartupRowCountry';
import './styles.scss';

function StartupRow({
  id,
  name,
  description,
  logo,
  verified,
  legalName,
  country,
  city,
  // url,
  // social,
  relation,
  loading,
  literals,
  literalsOnBoarding,
  user,
  refreshTable,
  setPendingStartups,
}) {
  const { dialog } = useDialog();
  const navigate = useNavigate();

  const handleChangeStatus = async (e, newStatus) => {
    e.preventDefault();
    const confirm = await dialog({
      type: newStatus === STARTUP_RELATION_STATUS.REJECTED ? 'confirmDanger' : 'confirm',
      text: newStatus === STARTUP_RELATION_STATUS.REJECTED ? literals.confirmReject : literals.confirmAccept,
    });
    if (confirm) {
      await dialog({
        type: 'loading',
        execute: async () => {
          await changeInviteStatus(id, user.id, newStatus);
          if (typeof refreshTable === 'function') {
            setPendingStartups(prev => prev.filter(startup => startup.id !== id));
            if (newStatus === STARTUP_RELATION_STATUS.ACCEPTED) {
              refreshTable();
            }
          }
        },
      });
    }
  };

  if (loading) {
    return <StartupRowLoading id={id} />;
  }

  return (
    <div
      key={id}
      onClick={() => (relation?.status === 'accepted' ? navigate(ROUTE_STARTUP_PATH.setHome(id)) : null)}
    >
      <div className={`startup ${relation?.status === STARTUP_RELATION_STATUS.ACCEPTED ? STARTUP_RELATION_STATUS.ACCEPTED : STARTUP_RELATION_STATUS.PENDING}`}>
        <StartupRowHeader
          name={name}
          logo={logo}
          verified={verified}
          legalName={legalName}

        />
        <StartupRowCountry
          country={country}
          city={city}
          literalsOnBoarding={literalsOnBoarding}
        />
        {/* <StartupRowSocial url={url} social={social} /> */}
        <div className='company_description'>{description}</div>
        <StartupRowButtons
          relation={relation}
          literals={literals}
          handleChangeStatus={handleChangeStatus}
        />
      </div>
    </div>
  );
}

StartupRow.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  description: PropTypes.string,
  logo: PropTypes.object,
  verified: PropTypes.string,
  legalName: PropTypes.string,
  country: PropTypes.string,
  city: PropTypes.string,
  // url: PropTypes.string,
  // social: PropTypes.object,
  relation: PropTypes.object,
  loading: PropTypes.bool,
  literals: PropTypes.object.isRequired,
  literalsOnBoarding: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  refreshTable: PropTypes.func,
  setPendingStartups: PropTypes.func,
};

export default StartupRow;
